<template>
  <div class="f-hdwrap">
    <!-- PC：顶部横向导航 -->
    <header class="f-hd" v-if="!isMobile">
      <div class="f-wrap f-hd-in">
        <router-link to="/" class="f-hd-brand"><brandF /></router-link>

        <nav class="f-hd-nav">
          <a href="javascript:;" :class="{ on: active === 'home' }" @click="go('/')">{{ $t('home') }}</a>
          <a href="javascript:;" :class="{ on: active === 'topup' }" @click="goCatalog('4')">{{ $t('game_top_up') }}</a>
          <a href="javascript:;" :class="{ on: active === 'vouch' }" @click="goCatalog('5')">{{ $t('game_vouchers') }}</a>
          <a href="javascript:;" :class="{ on: active === 'mobile' }" @click="go('/mobile')">
            {{ $t('pulsa') }} &amp; {{ $t('data') }}
            <i class="f-new">{{ $t('new_badge') }}</i>
          </a>
        </nav>

        <a class="f-hd-search" href="javascript:;" @click="openSearch">
          <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.6" /><path d="m19.6 19.6-3.4-3.4" /></svg>
          <span>{{ $t('f_search_cta') }}</span>
          <kbd>/</kbd>
        </a>

        <a-dropdown placement="bottomRight" :trigger="['click']">
          <a class="f-hd-lang" href="javascript:;" @click="(e) => e.preventDefault()">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c2.6 2.6 3.8 5.6 3.8 9s-1.2 6.4-3.8 9c-2.6-2.6-3.8-5.6-3.8-9S9.4 5.6 12 3z" /></svg>
            {{ country }}
          </a>
          <a-menu class="f-langmenu" slot="overlay" @click="changeLang">
            <a-menu-item v-for="item in lang" :key="item.key">
              <a href="javascript:;">{{ item.label }}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </header>

    <!-- 移动端：顶栏 + 底部 Tab -->
    <template v-if="isMobile">
      <div class="f-mtop">
        <router-link to="/" class="f-hd-brand"><brandF /></router-link>
        <!-- 搜索在底部 Tab 里，顶栏只放语言 -->
        <span class="ic">
          <a-dropdown placement="bottomRight" :trigger="['click']">
            <span @click="(e) => e.preventDefault()">{{ country }}</span>
            <a-menu class="f-langmenu" slot="overlay" @click="changeLang">
              <a-menu-item v-for="item in lang" :key="item.key">
                <a href="javascript:;">{{ item.label }}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </div>

      <nav class="f-mtab">
        <a href="javascript:;" :class="{ on: active === 'home' }" @click="go('/')">
          <svg viewBox="0 0 24 24"><path d="M3.5 10.5 12 3.8l8.5 6.7V20a1 1 0 0 1-1 1h-4.5v-6h-6v6H4.5a1 1 0 0 1-1-1z" /></svg>{{ $t('home') }}
        </a>
        <a href="javascript:;" :class="{ on: active === 'topup' }" @click="goCatalog('4')">
          <svg viewBox="0 0 24 24"><path d="M13 2.5 4.5 14H11l-1 7.5L19.5 10H13z" /></svg>{{ $t('top_up') }}
        </a>
        <!-- 中间一格是凸起的口袋按钮，进话费 -->
        <a href="javascript:;" class="mid" :class="{ on: active === 'mobile' }" @click="go('/mobile')">
          <span class="pk"><brandF tone="dark" :markOnly="true" /></span>{{ $t('mobile_nav') }}
        </a>
        <a href="javascript:;" :class="{ on: active === 'vouch' }" @click="goCatalog('5')">
          <svg viewBox="0 0 24 24"><path d="M3 7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3a2 2 0 0 0 0 4v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3a2 2 0 0 0 0-4z" /><path d="M14.5 6v12" stroke-dasharray="2 2" /></svg>{{ $t('vouchers') }}
        </a>
        <a href="javascript:;" @click="openSearch">
          <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.6" /><path d="m19.6 19.6-3.4-3.4" /></svg>{{ $t('search') }}
        </a>
      </nav>
    </template>

    <!-- 整页搜索覆盖层 -->
    <transition name="f-fade">
      <div class="f-srch" v-if="searchOpen" @click.self="closeSearch">
        <div class="f-srch-box">
          <div class="ln">
            <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.6" /><path d="m19.6 19.6-3.4-3.4" /></svg>
            <SearchBox ref="search" :searchVal="searchVal" :clear="clearValue" :placeholder="$t('f_search_cta')" @onsearch="handleSearch" />
            <span class="cls" @click="closeSearch">Esc</span>
          </div>

          <div class="res">
            <template v-if="searchVal">
              <template v-if="gameListInfo.length > 0">
                <div class="f-lbl">{{ gameListInfo.length }} {{ $t('search_results') }}</div>
                <ul class="f-sres">
                  <li v-for="item in gameListInfo" :key="item.id" @click="toPayCheckout(item.id)">
                    <span class="th"><img :src="picUrl(item.gamePic)" :alt="item.gameName" /></span>
                    <span class="tx">
                      <p class="nm" v-html="highlightedItem(item.gameName)"></p>
                      <span class="sb">{{ item.gameId }}</span>
                    </span>
                    <span class="go">⚡ {{ $t('top_up') }}</span>
                  </li>
                </ul>
              </template>

              <div class="f-empty" v-else>
                <span class="ic"><brandF :markOnly="true" /></span>
                <h4>{{ $t('no_results_found') }}</h4>
                <p>{{ $t('no_results_hint') }}</p>
                <a class="f-btn" href="javascript:;" @click="goCatalog('4')">{{ $t('browse_all_games') }}</a>
              </div>
            </template>

            <div class="f-srch-hint" v-else>
              <div class="f-lbl">{{ $t('search_placeholder_hint') }}</div>
              <div class="chips">
                <a href="javascript:;" @click="goCatalog('4')">⚡ {{ $t('game_top_up') }}</a>
                <a href="javascript:;" @click="goCatalog('5')">🎟 {{ $t('game_vouchers') }}</a>
                <a href="javascript:;" @click="go('/mobile')">📱 {{ $t('pulsa') }} &amp; {{ $t('data') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SearchBox from './components/searchE.vue'
import brandF from './components/brandF.vue'
import i18n from '../i18n'
import utils from '@/assets/js/common'
import dh from '@/assets/js/dHelpers'

export default {
  components: { SearchBox, brandF },
  data() {
    return {
      isMobile: false,
      searchOpen: false,
      searchVal: '',
      country: 'EN',
      lang: [{ key: 'en-US', label: 'EN' }],
      gameListInfo: [],
      currency: this.$store.state.orderInfo.gameCurrency,
    }
  },
  computed: {
    active() {
      const path = this.$route.path
      if (path === '/') return 'home'
      if (path.indexOf('/topup/') === 0) return 'topup'
      if (path.indexOf('/mobile') === 0) return 'mobile'
      if (path.indexOf('/catalog') === 0) return (this.$route.query.type || '4') === '5' ? 'vouch' : 'topup'
      return ''
    },
  },
  watch: {
    $route() {
      this.closeSearch()
    },
  },
  mounted() {
    this.isMobile = dh.isMobileUA()
    document.addEventListener('keydown', this.onKey)
    this.$root.$on('f-open-search', this.openSearch)

    const currentLang = localStorage.getItem('lang')

    // 语言列表按域名动态拼，与其他皮肤保持一致
    if (this.currency == null) {
      const localHost = location.host;
      if (localHost.indexOf('la') > 0) {
        this.lang.push({ key: 'pt-BR', label: 'BR' }, { key: 'es-MX', label: 'MX' })
      } else if (localHost.indexOf('th') > 0) {
        this.lang.push({ key: 'th-TH', label: 'TH' })
      } else if (localHost.indexOf('ph') > 0) {
        this.lang.push({ key: 'fil-PH', label: 'PH' })
      } else if (localHost.indexOf('pg') > 0) {
        this.lang.push(
          { key: 'my-MM', label: 'MM' },
          { key: 'ms-MY', label: 'MY' },
          { key: 'vi-VN', label: 'VN' },
        )
      } else {
        this.lang.push({ key: 'id-ID', label: 'ID' })
      }
    } else {
      const currencyEnum = utils.getCurrencyByCode(this.currency)
      this.lang.push({ key: currencyEnum.language, label: currencyEnum.country })
    }

    this.lang.forEach(element => {
      if (currentLang && currentLang.indexOf(element.key) !== -1) {
        this.country = element.label
        i18n.locale = element.key
        this.$global.lang = element.label
        this.$store.commit('setCountry', element.label);
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKey)
    this.$root.$off('f-open-search', this.openSearch)
  },
  methods: {
    picUrl(pic) {
      return dh.gamePic(pic)
    },
    // PC 上按 / 打开搜索，Esc 关掉
    onKey(e) {
      if (e.key === 'Escape' && this.searchOpen) {
        this.closeSearch()
        return
      }
      const tag = (e.target && e.target.tagName) || ''
      if (e.key === '/' && !this.searchOpen && !/INPUT|TEXTAREA/.test(tag)) {
        e.preventDefault()
        this.openSearch()
      }
    },
    go(path) {
      this.closeSearch()
      if (this.$route.path === path) return;
      this.$router.push({ path })
    },
    goCatalog(type) {
      this.closeSearch()
      if (this.$route.path === '/catalog' && (this.$route.query.type || '4') === type) return;
      this.$router.push({ path: '/catalog', query: { type } })
    },
    openSearch() {
      this.searchOpen = true
      this.$nextTick(() => {
        const box = this.$refs.search
        if (box && box.focus) box.focus()
      })
    },
    closeSearch() {
      this.searchOpen = false
      this.searchVal = ''
      this.gameListInfo = []
      const box = this.$refs.search
      if (box) box.clearValue()
    },
    clearValue() {
      this.searchVal = '';
      this.gameListInfo = []
    },
    toPayCheckout(gameId) {
      this.closeSearch()
      this.$router.push({ path: `/topup/${gameId}` })
    },
    highlightedItem(gameName) {
      if (!this.searchVal) return gameName;
      const safe = this.searchVal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const pattern = new RegExp(`(${safe})`, 'gi');
      return gameName.replace(pattern, '<span class="highlighted">$1</span>');
    },
    handleSearch(keyword) {
      this.searchVal = keyword
      this.fuzzyQuery(keyword)
    },
    // 搜索接口
    fuzzyQuery(gameId) {
      if (gameId === '') {
        this.gameListInfo = []
        return;
      }
      const formdata = {
        gameName: gameId,
        lang: this.country != null && this.country != '' ? this.country.toString().toLowerCase() : 'en',
      }
      this.$httpReqest('/tikishop/game/fuzzyQuery', formdata)
        .then((res) => {
          if (res.code == '200') {
            this.gameListInfo = res.gameListInfo || []
          } else {
            console.log(res.msg)
          }
        })
        .catch((err) => {
          console.log('fuzzyQuery err!', err)
        })
    },
    // 菜单 key 用语言码而不是下标，避免同级重复 key
    changeLang(obj) {
      const item = this.lang.find(l => l.key === obj.key)
      if (!item) return;
      this.country = item.label
      localStorage.setItem('lang', JSON.stringify(item.key))
      i18n.locale = item.key
      this.$global.lang = item.label;
      this.$store.commit('setCountry', item.label);
    },
  },
}
</script>
